import { render, staticRenderFns } from "./DocumentDeletingWarning.vue?vue&type=template&id=2893e200&"
import script from "./DocumentDeletingWarning.vue?vue&type=script&lang=js&"
export * from "./DocumentDeletingWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports